import './header.css';

import React, { useContext, useEffect, useRef, useState } from 'react';

import { Link } from 'gatsby';
import Popup from '../../shared/popup';
import PropTypes from 'prop-types';
import Sticky from 'react-stickynode';
import { TrafficSourceContext } from '../../shared/traffic-source-listener';
import classnames from 'classnames';
import logo from '../../../images/nav/logo-new.webp';
import logoWhite from '../../../images/nav/logo-white.svg';
import netsurfplayLogo from '../../../images/icons/play.svg';
import netsurfplayLogoDark from '../../../images/icons/play-dark.png';
import pages from '../../../constants/pages';
import scrollTo from 'gatsby-plugin-smoothscroll';

const { links: mainNavigationLinks } = pages;

const Header = ({ activeTab, landing }) => {
	const [isNavbarOpen, setNavbarOpen] = useState(false);
	const [showTelephonePopover, setShowTelephonePopover] = useState(false);
	const target = useRef(null);
	const wrapperRef = useRef(null);
	const topNavRef = useRef(null);
	const { supportPhone, signupPhone } = useContext(TrafficSourceContext);

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	});

	const handleClickOutside = (event) => {
		if (
			wrapperRef.current &&
			!wrapperRef.current.contains(event.target) &&
			!topNavRef.current.contains(event.target)
		) {
			setNavbarOpen(false);
		}
	};

	return (
		<header>
			<div>
				{/* <TopBar></TopBar> */}

				<Sticky enable={true} innerZ={50}>
					<TopNavigation
						isNavbarOpen={isNavbarOpen}
						passRef={topNavRef}
						supportPhone={supportPhone}
						signupPhone={signupPhone}
					/>
					<MainNavigation
						passRef={wrapperRef}
						isNavbarOpen={isNavbarOpen}
						setNavbarOpen={(v) => setNavbarOpen(v)}
						showTelephonePopover={showTelephonePopover}
						setShowTelephonePopover={(v) => setShowTelephonePopover(v)}
						target={target}
						activeTab={activeTab}
						landing={landing}
						supportPhone={supportPhone}
						signupPhone={signupPhone}
					/>
				</Sticky>
			</div>
		</header>
	);
};

const MainNavigation = ({
	isNavbarOpen,
	setNavbarOpen,
	showTelephonePopover,
	setShowTelephonePopover,
	target,
	activeTab,
	passRef,
	landing,
	supportPhone,
	signupPhone
}) => {
	const isHomePage = activeTab === '/';

	return (
		<nav
			className={
				'navbar navbar-dark navbar-expand-lg d-flex justify-content-between main-navbar px-lg-5 ' +
				(isNavbarOpen && 'open nav-width-mobile')
			}
			ref={passRef}
		>
			<button
				className="navbar-toggler"
				type="button"
				onClick={(_) => {
					setNavbarOpen(!isNavbarOpen);
				}}
			>
				{isNavbarOpen ? (
					<span className="icon navbar-toggler-close-icon"></span>
				) : (
					<span className="navbar-toggler-icon"></span>
				)}
			</button>
			<Logo isNavbarOpen={isNavbarOpen} logo={logo} logoWhite={logoWhite} />
			<div className="d-lg-none d-block">
				<button
					className="navbar-toggler"
					ref={target}
					id="scta-call-mobile"
					onClick={(_) => setShowTelephonePopover(!showTelephonePopover)}
					type="button"
				>
					<span className="icon telephone-toggler-icon"></span>
				</button>
				<Popup
					onHide={() => setShowTelephonePopover(false)}
					showTelephonePopover={showTelephonePopover}
					setShowTelephonePopover={(v) => setShowTelephonePopover(v)}
					target={target}
				>
					<div className="py-4 pl-4 pr-3 popup d-flex justify-content-end align-items-end">
						<div className="text-right">
							<div className="my-2">
								<p className="number-blue">Текущи клиенти:</p>
								<h2 className="number">
									<a href={`tel:${supportPhone}`}>{supportPhone}</a>
								</h2>
							</div>
							<div className="my-2">
								<p className="number-green">Нови клиенти:</p>
								<h2 className="number">
									<a href={`tel:${signupPhone}`}>{signupPhone}</a>
								</h2>
							</div>
						</div>
					</div>
				</Popup>
			</div>
			<div className="order-2 d-xl-flex justify-content-between d-none">
				{!landing && (
					<>
						{isHomePage ? (
							<button
								className="btn btn-primary green header-button"
								id="pcta-header"
								onClick={() => {
									scrollTo('#package-section', 'start');
								}}
							>
								Виж пакетите
							</button>
						) : (
							<Link
								to={'/za-doma/'}
								className="btn btn-primary green header-button"
								id="pcta-header"
							>
								Виж пакетите
							</Link>
						)}
					</>
				)}
			</div>
			<div
				className={
					'navbar-collapse collapse w-100 order-2 order-md-0 bottom-radius-sm ' +
					(isNavbarOpen && 'show')
				}
			>
				<NavigationRenderer
					navigationLinks={mainNavigationLinks}
					activeTab={activeTab}
					isNavbarOpen={isNavbarOpen}
				/>
			</div>

			{landing === 'koleda2020FB' && (
				<a
					className="btn btn-primary green header-button"
					href="tel:+359882991614"
				>
					088 299 1614
				</a>
			)}

			{landing === 'koleda2020GA' && (
				<a
					className="btn btn-primary green header-button"
					href="tel:+359882991613"
				>
					088 299 1613
				</a>
			)}
		</nav>
	);
};

const NavigationRenderer = ({ navigationLinks, activeTab, isNavbarOpen }) => {
	const RenderLinkNode = ({ link, isNavbarOpen }) => {
		const {
			name,
			href,
			dropdownItems,
			showPromoIcon,
			externalHref,
			showPlayIcon
		} = link;
		const linkTarget = useRef(null);
		const [showPopup, setShowPopup] = useState(false);

		const hasDropdownItems = dropdownItems && dropdownItems.length > 0;

		if (hasDropdownItems && isNavbarOpen) {
			return (
				<>
					{dropdownItems.map((link, index) => (
						<RenderLinkNode key={index} link={link} />
					))}
				</>
			);
		}
		return (
			<>
				<li className="mx-3 mt-2 nav-item mt-lg-3 d-flex justify-content-center align-items-center">
					{showPlayIcon && (
						<>
							{isNavbarOpen ? (
								<img
									className="mr-1"
									src={netsurfplayLogo}
									width={30}
									height={30}
								/>
							) : (
								<img
									className="mr-1"
									src={netsurfplayLogoDark}
									width={36}
									height={36}
								/>
							)}
						</>
					)}
					<Link
						to={href}
						className={classnames('nav-link d-inline-block', {
							active: activeTab && activeTab === href,
							promotion: showPromoIcon,
							'is-dropdown': hasDropdownItems,
							'dropdown-open': showPopup
						})}
						ref={linkTarget}
						onClick={(e) => {
							if (hasDropdownItems) {
								e.preventDefault();
								setShowPopup(!showPopup);
							}
							if (externalHref) {
								window.location.href = externalHref;
							}
						}}
						onMouseOver={() => setShowPopup(true)}
						onMouseOut={() => setShowPopup(false)}
					>
						<span>{name}</span>
						{hasDropdownItems && (
							<>
								<Popup
									onHide={() => setShowPopup(false)}
									showTelephonePopover={showPopup}
									setShowTelephonePopover={setShowPopup}
									target={linkTarget}
									placement={'bottom'}
								>
									<div className="px-4 py-3 popup d-block">
										{hasDropdownItems &&
											dropdownItems.map(
												(
													{
														href,
														name,
														external,
														externalHref
													},
													index
												) => (
													<div className="my-2">
														<Link
															key={index}
															to={href}
															className={classnames(
																'nav-link d-inline-block',
																{
																	active:
																		activeTab &&
																		activeTab === href
																}
															)}
															onClick={() => {
																if (externalHref) {
																	window.location.href = externalHref;
																}
															}}
														>
															{name}
														</Link>
													</div>
												)
											)}
									</div>
								</Popup>
							</>
						)}
					</Link>
				</li>
			</>
		);
	};

	return (
		<>
			<ul className="mx-auto navbar-nav">
				{navigationLinks &&
					navigationLinks.map((link, index) => (
						<RenderLinkNode
							key={index}
							link={link}
							activeTab={activeTab}
							isNavbarOpen={isNavbarOpen}
						/>
					))}
				<li className="mx-3 my-4 nav-item mt-lg-3 text-center">
					{isNavbarOpen && (
						<>
							<Link
								to="/za-doma/"
								className="btn btn-primary green"
								id="pcta-burger"
							>
								Виж пакетите
							</Link>
						</>
					)}
				</li>
			</ul>
		</>
	);
};

const TopNavigation = ({ isNavbarOpen, passRef, supportPhone, signupPhone }) => {
	const target = useRef(null);
	const [show, setShow] = useState(false);

	return (
		<div className={'top-nav ' + (isNavbarOpen && 'open')} ref={passRef}>
			<div className="row mx-lg-5 h-100">
				<div className="col-4 d-none d-lg-flex justify-content-start align-items-center pl-lg-5 h-100"></div>
				<div className="col-lg-3 d-none d-lg-block"></div>
				<div
					className={
						'col-12 col-lg-5 d-flex align-self-center align-items-center ' +
						(isNavbarOpen ? 'justify-content-end' : 'justify-content-end')
					}
				>
					{!isNavbarOpen && (
						<>
							<div className="topnav-item d-none d-lg-flex justify-content-start align-items-center px-lg-3">
								<div className="mr-3">
									<span className="mr-1 icon phone-icon d-none d-lg-inline-block"></span>
								</div>
								<div className="mr-3">
									<a
										className="contact-number sign-up"
										href={`tel:${signupPhone}`}
									>
										{signupPhone}
									</a>
									<p className="contact-number-undertext">
										нови клиенти
									</p>
								</div>
								<div className="">
									<a
										className="contact-number current"
										href={`tel:${supportPhone}`}
									>
										{supportPhone}
									</a>
									<p className="contact-number-undertext">
										текущи клиенти
									</p>
								</div>
							</div>
							<div className="topnav-item-divider" />
							<div className="px-3 topnav-item d-inline px-lg-4">
								<Link to={'/pokritie/'}>Покритие</Link>
							</div>
							<div className="topnav-item-divider" />
							<div className="px-3 topnav-item d-inline px-lg-4">
								<Link to={'/magazini/'}>Магазини</Link>
							</div>
							<div className="topnav-item-divider d-none d-lg-block" />
							<div className="topnav-item d-none d-lg-inline pl-lg-4 pr-lg-2">
								<a
									href="https://userportal.net-surf.net/login"
									className="btn btn-secondary btn-sm"
									target={'_blank'}
									rel={'noopener noreferrer'}
								>
									Плати сметката си
								</a>
							</div>
						</>
					)}

					<Popup
						showTelephonePopover={show}
						setShowTelephonePopover={(v) => setShow(v)}
						target={target}
						onHide={() => setShow(false)}
					>
						<div className="py-4 pl-4 pr-3 popup d-flex justify-content-end align-items-end">
							<div className="text-right justify-content-between">
								<div className="my-2">
									<p className="number-blue">Текущи клиенти:</p>
									<h2 className="number">
										<a href={`tel:${supportPhone}`}>{supportPhone}</a>
									</h2>
								</div>
								<div className="my-2">
									<p className="number-green">Нови клиенти:</p>
									<h2 className="number">
										<a href={`tel:${signupPhone}`}>{signupPhone}</a>
									</h2>
								</div>
							</div>
						</div>
					</Popup>

					{isNavbarOpen && (
						<div className="topnav-item d-inline-flex justify-content-between w-100 pl-lg-2">
							<a
								href="https://userportal.net-surf.net/login"
								className="btn btn-primary green btn-sm"
								style={{ marginLeft: 40 }}
								target={'_blank'}
								rel={'noopener noreferrer'}
							>
								Плати сметката си
							</a>
							<div className="d-flex align-items-center">
								<img
									className="mr-1"
									src={netsurfplayLogo}
									width={25}
									height={25}
								/>
								<a
									className={
										'ml-lg-0 d-inline-block ' +
										(isNavbarOpen && 'text-white')
									}
									rel={'noopener noreferrer'}
									href="https://userportal.net-surf.net/login"
								>
									Вход
								</a>
							</div>
						</div>
					)}

					<div className="topnav-item d-none d-lg-inline-block pl-lg-2">
						<img
							className="mr-1"
							src={netsurfplayLogoDark}
							width={36}
							height={36}
						/>
						<a
							href="https://userportal.net-surf.net"
							className="ml-lg-0 d-inline-block text-purple text-bold"
						>
							Вход
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};

const Logo = ({ isNavbarOpen, logoWhite, logo }) => (
	<Link to={'/'} className={'ml-xl-4 d-block text-center order-0 order-md-0 '}>
		<img src={isNavbarOpen ? logoWhite : logo} className="logo" alt="Logo" />
	</Link>
);

Header.propTypes = {
	siteTitle: PropTypes.string
};

Header.defaultProps = {
	siteTitle: ``
};

export default Header;

